import React from 'react';
import styles from './CreateSubscriptionModal.module.css';

export interface ModalSummaryItem {
  label: string;
  value: React.ReactNode;
}

interface ModalSummaryProps {
  items: readonly ModalSummaryItem[];
}

const ModalSummary: React.FC<ModalSummaryProps> = ({ items }) => (
  <div className={styles['plan-summary']}>
    {items.map((item) => (
      <div key={item.label} className={styles['plan-summary-row']}>
        <span className={styles['plan-summary-label']}>{item.label}</span>
        <span className={styles['plan-summary-value']}>{item.value}</span>
      </div>
    ))}
  </div>
);

export default ModalSummary;
